// 会計画面の支払行(お預かり)と会計手数料の純関数群。
// 支払行は「元金(baseAmount)」を入力値として持ち、請求額(amount) = baseAmount + processingFee を保存時に導出する。
// DB上の payments.amount は請求額(手数料込み)、payments.processing_fee は手数料、という既存仕様は変えない。

const toNumber = value => {
  const n = Number(value)

  return Number.isFinite(n) ? n : 0
}

// 支払行の請求額(元金 + 手数料)
export const paymentAmount = row => toNumber(row.baseAmount) + toNumber(row.processingFee)

// 指定行を除いた「未収残額」を元金ベースで返す。
// 請求合計 = total − discountFee + Σ全行の手数料、支払合計 = Σ全行の(元金+手数料) + extraPaid なので、
// 自行を除くと手数料が相殺され、残額 = total − discountFee − Σ他行の元金 − extraPaid になる。
export const remainingBaseAmount = ({
  total, discountFee = 0, payments = [], index, extraPaid = 0,
}) => {
  const othersBase = payments.reduce((acc, row, i) => {
    // eslint-disable-next-line no-underscore-dangle
    if (i === index || row._destroy) return acc

    return acc + toNumber(row.baseAmount)
  }, 0)
  const remaining = toNumber(total) - toNumber(discountFee) - othersBase - toNumber(extraPaid)

  return Math.max(Math.round(remaining), 0)
}

// カード選択時に手数料を自動適用するか
export const shouldAutoApply = ({ autoApplicable, paymentMethod }) => Boolean(autoApplicable) && paymentMethod === 'card'

// 保存用ペイロード: amount は請求額(元金+手数料)。請求額が0の行は送らない(既存仕様)
export const toPaymentsPayload = rows => rows
  .map(row => ({
    id: row.id,
    amount: paymentAmount(row),
    paymentMethod: row.paymentMethod,
    isFractionAdjustment: Boolean(row.isFractionAdjustment),
    processingFee: toNumber(row.processingFee),
    // eslint-disable-next-line no-underscore-dangle
    _destroy: Boolean(row._destroy),
  }))
  .filter(row => row.amount > 0)

// 保存済み payments(JSON:API の data 配列)から支払行を復元する。元金 = 請求額 − 手数料。
// 行の値は書き換えない(旧伝票の手数料は legacyProcessingFeeOf で別項として扱う)
export const restorePaymentRows = (apiPayments = []) => apiPayments.map(payment => {
  const {
    amount, paymentMethod, isFractionAdjustment, processingFee,
  } = payment.attributes
  const fee = toNumber(processingFee)

  return {
    id: payment.id,
    baseAmount: toNumber(amount) - fee,
    processingFee: fee,
    paymentMethod,
    isFractionAdjustment: Boolean(isFractionAdjustment),
    _destroy: false,
  }
})

// 旧伝票(2026-04以前: 支払行の processing_fee が全て0で伝票側だけ手数料を持つ)の手数料。
// どの行の分か特定できないため行には帰属させず、合計にだけ足す別項として返す。行に手数料があれば0
export const legacyProcessingFeeOf = (rows = [], receiptProcessingFee = 0) => {
  const rowsFeeTotal = rows.reduce((acc, row) => acc + toNumber(row.processingFee), 0)
  const receiptFee = toNumber(receiptProcessingFee)

  return rowsFeeTotal === 0 && receiptFee > 0 ? receiptFee : 0
}
